import { render, staticRenderFns } from "./DispatchCandidateDialog.vue?vue&type=template&id=3913a31a&scoped=true"
import script from "./DispatchCandidateDialog.vue?vue&type=script&lang=js"
export * from "./DispatchCandidateDialog.vue?vue&type=script&lang=js"
import style0 from "./DispatchCandidateDialog.vue?vue&type=style&index=0&id=3913a31a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3913a31a",
  null
  
)

export default component.exports